import TubCommon from "./tubCommon";
import {getSkuWithoutDot} from "../../../lookNavigation/lookFunctions2";

export default class WalkInTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'walk_in_tub';
    this.bottomTubId = "walk_in_tub";
    this.visible = true;
    this.partName = 'Walk In Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.walk_in_tub";
    this.isStoneFeature = false;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    if (dbFeature.metaData["ActualDisplayedName"] && dbFeature.metaData["ActualDisplayedName"][0]) {
      dbFeature.metaData["ActualDisplayedName"] = getSkuWithoutDot(dbFeature.metaData["ActualDisplayedName"][0]);
    } else {
      dbFeature.metaData["ActualDisplayedName"] = getSkuWithoutDot(dbFeature.sharedFeatureName);
    }
    return super.load_(dbFeature, new WalkInTub());
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

}
